<!-- <mat-toolbar color="primary" class="nav-header">
    <mat-toolbar-row>
        <div class="col-md-8 justify-content-start" style="margin-top: -4px;">
           
            <img src="../../../assets/images/afs-logo.png" alt="Logo" class="login-logo"/>
        </div>
        <span class="menu-spacere"></span>
        <div class="col-md-4 txt-right">
            <a mat-button [routerLink]="'/register'">home</a>
            <a mat-button [matMenuTriggerFor]="userMenu">Profile</a>
            <mat-menu #userMenu>
                <a mat-menu-item><i class="fa fa-user-circle-o right-margin-10"> </i> My Profile</a>
                <a mat-menu-item><i class="fa fa-sign-out right-margin-10"> </i> Change Password</a>
                <a mat-menu-item><i class="fa fa-key right-margin-10"> </i>  Logout</a>
            </mat-menu>
        </div>
    </mat-toolbar-row>
  </mat-toolbar> -->

<mat-toolbar color="primary" class="main-header">
    <mat-toolbar-row>
        <div class="col-md-2 justify-content-start" style="margin-top: -4px;">
            <button mat-icon-button>
                <mat-icon (click)="drawer.toggle()">menu</mat-icon>
            </button>
            <img src="../../../assets/images/afs-logo.png" alt="Logo" class="login-logo" />
        </div>
        <div class="col-md-7 justify-content-start">
            <button mat-button class="navbtn"><i class="fa fa-home right-margin-10"> </i> Home</button>
            <button mat-button class="navbtn active" [routerLink]="'/dashboard'"><i
                    class="fa fa-tachometer right-margin-10"> </i> Dashboard</button>
            <button mat-button [matMenuTriggerFor]="animals" class="navbtn"> <i
                    class="fa fa-user-circle-o right-margin-10"> </i>Operations</button>
            <mat-menu #animals="matMenu">
                <button mat-menu-item [matMenuTriggerFor]="mennu">Menu</button>
                <button mat-menu-item [matMenuTriggerFor]="refund">Refund & Disputes</button>
                <button mat-menu-item [matMenuTriggerFor]="remittance">Managing Remittance </button>
                <button mat-menu-item [matMenuTriggerFor]="revenue">Revenue share </button>
                <button mat-menu-item [matMenuTriggerFor]="utility">Utility </button>
                <button mat-menu-item [routerLink]="'/vendorinfo'">Vendor Info</button>
                <button mat-menu-item [routerLink]="'/customerProfileSetup'">Customer Profile Setup</button>
                <button mat-menu-item [routerLink]="'/customerBankAccountSetup'">Bank Account Setup</button>

                <mat-menu #mennu="matMenu">
                    <button mat-menu-item [routerLink]="'/payments'">Payment</button>
                    <button mat-menu-item [routerLink]="'/settlements'">Settlements</button>
                    <button mat-menu-item [routerLink]="'/remittances'">Remittances</button>
                </mat-menu>

                <mat-menu #refund="matMenu">
                    <button mat-menu-item [routerLink]="'/refund'">Refund</button>
                    <button mat-menu-item [routerLink]="'/disputes'">Disputes</button>
                </mat-menu>

                <mat-menu #remittance="matMenu">
                    <button mat-menu-item [routerLink]="'/Remit'">Remit Manager</button>
                    <button mat-menu-item [routerLink]="'/cash'">CashPro Batch</button>
                    <button mat-menu-item [routerLink]="'/opssheet'">Ops Sheet</button>
                    <button mat-menu-item [routerLink]="'/completion'">Completion Remit</button>
                    <button mat-menu-item [routerLink]="'/Bkremit'">BK Remit</button>
                </mat-menu>

                <mat-menu #revenue="matMenu">
                    <button mat-menu-item [routerLink]="'/revenue'">Revenue Share </button>
                    <button mat-menu-item [routerLink]="'/bkrevshare'">BK RevShare</button>
                    <button mat-menu-item [routerLink]="'/remittances'">Remittances</button>
                </mat-menu>

                <mat-menu #utility="matMenu">
                    <button mat-menu-item [routerLink]="'/transactional'">Transactional Grid </button>
                    <button mat-menu-item [routerLink]="'/bkrevshare'">90 days</button>
                    <button mat-menu-item [routerLink]="'/accounting'">Accounting</button>
                    <button mat-menu-item [routerLink]="'/import'">Import</button>
                    <button mat-menu-item [routerLink]="'/monthlyaccounting'">Mothly Accounting</button>
                </mat-menu>

            </mat-menu>
        </div>
        <div class="col-md-3 txt-right">
            <a mat-button [routerLink]="'/login'">Login</a>
            <a mat-button [matMenuTriggerFor]="userMenu">Profile</a>
            <mat-menu #userMenu>
                <a mat-menu-item><i class="fa fa-user-circle-o right-margin-10"> </i> My Profile</a>
                <a mat-menu-item><i class="fa fa-sign-out right-margin-10"> </i> Change Password</a>
                <a mat-menu-item><i class="fa fa-key right-margin-10"> </i> Logout</a>
            </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<ng-container>
    <mat-drawer-container class="sidenav-container">
        <mat-drawer mode="side" opened #drawer>
            <mat-nav-list>
                <a mat-list-item [routerLink]="'/products'">Products</a>
                <a mat-list-item [routerLink]="'/dashboard'">Dashboard</a>
            </mat-nav-list>
        </mat-drawer>
        <mat-drawer-content>
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</ng-container>